import apiFetch from '../../apiFetch'

export default function (token) {
  return apiFetch({ endPoint: 'Dossier/Purchase/GetPurchaseLogisticStates', method: 'GET', token: token })
}
